export default "__VITE_ASSET__CcwMGK4S__";